import { Box, Heading, Text } from '@wix/design-system';
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';

import { AI_MODAL_ERROR_CONTAINER } from '../data-hooks';
import { ErrorIllustration } from './error-illustration';
import styles from './error-message-scss';

export const ErrorMessage: React.FC = () => {
  const { t } = useContext(RicosContext);
  return (
    <Box
      dataHook={AI_MODAL_ERROR_CONTAINER}
      align="center"
      direction="vertical"
      gap="SP2"
      paddingBottom="SP1"
      paddingLeft="SP5"
      paddingRight="SP5"
    >
      <ErrorIllustration />
      <Heading textAlign="center" size="medium">
        {t('AIPlugin_Error_Title')}
      </Heading>
      <Text className={styles.errorText} size="small" tagName="p">
        {t('AIPlugin_Error_Text')}
      </Text>
    </Box>
  );
};
